import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import React from 'react';

import Organization from 'entities/organization/model';

export const ProvisionalNonprofitDataBanner = ({
  organizationId,
  provisionalNonprofitData,
}: {
  organizationId?: string;
  provisionalNonprofitData?: Partial<Organization>;
}) =>
  !organizationId && provisionalNonprofitData ? (
    <>
      <Typography>
        This opportunity was imported with the following nonprofit information. You can search our
        database to attach a verified nonprofit or add a new one.
      </Typography>
      <Box my={2}>
        <Alert severity="info">
          <AlertTitle>Imported nonprofit data</AlertTitle>
          {provisionalNonprofitData.name && (
            <Typography>
              <strong style={{ fontWeight: 500 }}>Name</strong>: {provisionalNonprofitData.name}
            </Typography>
          )}
          {provisionalNonprofitData.brief && (
            <Typography>
              <strong style={{ fontWeight: 500 }}>Brief</strong>: {provisionalNonprofitData.brief}
            </Typography>
          )}
          {provisionalNonprofitData.website && (
            <Typography>
              <strong style={{ fontWeight: 500 }}>Website</strong>:{' '}
              <a target="_blank" href={provisionalNonprofitData.website}>
                {provisionalNonprofitData.website}
              </a>
            </Typography>
          )}
        </Alert>
      </Box>
    </>
  ) : null;
